import { render, staticRenderFns } from "./PartnersTariffs.vue?vue&type=template&id=10853a19"
import script from "./PartnersTariffs.vue?vue&type=script&lang=js"
export * from "./PartnersTariffs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports